@if (otherParamsScans?.paginationData?.totalRows && hasCheckpointScans) {
  <div class="d-flex justify-content-end">
    <div class="d-flex gap-2">
      <button
        [disabled]="!otherParamsScans?.paginationData?.totalRows"
        class="btn btn-danger btn-sm d-flex align-items-center gap-2"
        (click)="exportData('pdf')"
      >
        Export
        <i class="fa-regular fa-file-pdf fs-4"></i>
      </button>
      <button
        [disabled]="!otherParamsScans?.paginationData?.totalRows"
        class="btn btn-success btn-sm d-flex align-items-center gap-2"
        (click)="exportData('xlsx')"
      >
        Export
        <i class="fa-regular fa-file-excel fs-4"></i>
      </button>
    </div>
  </div>
}

<gtapp-gt-custom-table
  [deskTopTableData]="scanPaginationData[pageNumScans] || []"
  [desktopTableDetails]="scanDetailsTableView"
  [tableStyle]="tableStyle"
  [otherParams]="otherParamsScans"
  (sortColumn)="sortColumnScan($event)"
  (searchColumn)="searchColumnScan($event)"
  (rowClick)="openScanView($event, selectedEventDialogTemplate)"
  (paginationChange)="onChangePaginationScan($event)"
></gtapp-gt-custom-table>
@if (selectedEvent?.action && largeView) {
  <ng-template *ngTemplateOutlet="selectedEventDetailTemplate"></ng-template>
}
<ng-template #selectedEventDetailTemplate>
  <div class="row row-cols-1 row-cols-lg-3 align-start">
    <div class="col d-flex row-gap-3 column-gap-5 flex-wrap align-start p-lg-3">
      <dl>
        <dt>
          {{ selectedEvent?.action }}
        </dt>
        <dd>
          {{ selectedEvent?.detail }}
        </dd>
      </dl>

      <dl>
        <dt>Scanned At</dt>
        <dd>
          {{ selectedEvent?.updated_datetime | customDate: "d MMM y HH:mm" }}
        </dd>
      </dl>

      <dl>
        <dt>Site</dt>
        <dd>
          {{ selectedEvent?.site_name }}
        </dd>
      </dl>

      @if (selectedEvent | misc: "serverReceivedDateTimeCheck") {
        <dl>
          <dt class="text-danger fw-bold d-flex align-items-center">
            RECEIVED AT
            <span
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              class="ms-2"
              title="The time this event was uploaded."
            >
              <i class="fa-solid fa-circle-info"></i>
            </span>
          </dt>
          <dd>
            {{
              selectedEvent
                | misc: "serverReceivedDateTimeCheck"
                | customDate: "d MMM y HH:mm"
            }}
          </dd>
        </dl>
      }
      @if (selectedEvent?.prompts?.length) {
        <dl>
          @for (item of selectedEvent?.prompts; track item) {
            <div class="fw-bold">
              {{
                item?.prompt_data?.name
                  ? item?.prompt_data?.name
                  : "Mobile Form"
              }}
            </div>
            @for (dataItem of item?.data; track dataItem) {
              <div>
                <ng-template
                  *ngTemplateOutlet="
                    promptTemplate;
                    context: { value: dataItem }
                  "
                ></ng-template>
              </div>
            }
          }
        </dl>
      }
    </div>
    @if (selectedEvent?.file) {
      <div class="col">
        @if (selectedEvent?.file_additional_info?.uploading) {
          <div
            class="justify-content-end d-flex align-items-center gap-2 alert alert-info height-fit-content"
          >
            <div>File has not been uploaded to the server yet.</div>
            <div
              class="spinner-border text-dark spinner-border-sm"
              role="status"
            ></div>
          </div>
        } @else {
          <div (click)="onOpenFile(selectedEvent)">
            @if (
              [".mp4", ".mov", ".webm", ".mkv"].includes(
                selectedEvent?.file_extension
              )
            ) {
              <video
                controls
                style="
                  max-height: 100%;
                  max-width: 100%;
                  display: flex;
                  width: 100%;
                "
              >
                <source src="{{ selectedEvent?.file }}" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            } @else {
              <img
                class="cursor-pointer mw-100 border border-secondary"
                src="{{ selectedEvent?.file }}"
                alt="Guard Tracker"
              />
            }
          </div>
        }
      </div>
    }
    @if (selectedEvent?.gps?.lat) {
      <div class="col">
        <gtapp-map-leaflet
          [latLon]="selectedEvent?.gps"
          [scannedCheckpointDetails]="selectedEvent?.checkpoint_details"
          [mapId]="'event-location'"
        ></gtapp-map-leaflet>
      </div>
    }
  </div>
</ng-template>

<ng-template
  #selectedEventDialogTemplate
  let-selectedEventDialogTemplateRef="dialogRef"
>
  <div class="dialog-box card">
    <div class="card-header">
      <span class="float-end" (click)="selectedEventDialogTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <ng-template
        *ngTemplateOutlet="selectedEventDetailTemplate"
      ></ng-template>
    </div>
  </div>
</ng-template>

<ng-template let-dataItem="value" #promptTemplate>
  @if (dataItem?.description) {
    <div>
      <dl>
        <dt class="text-uppercase">{{ dataItem?.description }}</dt>
        <dd>{{ dataItem | misc: "promptValue" }}</dd>
      </dl>
    </div>
  }

  @if (dataItem?.file_id && promptFileDataUrls?.[dataItem?.file_id]?.file_url) {
    <img
      (click)="onOpenFile(promptFileDataUrls?.[dataItem?.file_id])"
      src="{{ promptFileDataUrls?.[dataItem?.file_id]?.file_url }}"
      height="120"
      width="120"
      class="small-img-preview"
    />
  }
  @for (option of dataItem?.options; track option) {
    <div>
      <ng-template
        *ngTemplateOutlet="promptTemplate; context: { value: option }"
      ></ng-template>
    </div>
  }
</ng-template>
